var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12"},[_c('indexHeader',{attrs:{"title":'التقارير',"description":'المبيعات بالفاتورة.'}}),_c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('searchInput',{staticClass:"col-md-3",attrs:{"title":"العميل","plaseholder":"اختر عميل","show":'name',"refrance":'id',"value":_vm.params.customer_id,"values":_vm.$database.customers},model:{value:(_vm.params.customer_id),callback:function ($$v) {_vm.$set(_vm.params, "customer_id", $$v)},expression:"params.customer_id"}}),_c('dateFilter',{staticClass:"col-md-3"}),_c('searchInput',{staticClass:"col-md-3",attrs:{"title":"المستخدم","plaseholder":"اختر مستخدم","show":'name',"refrance":'id',"value":_vm.params.user_id,"values":this.users},model:{value:(_vm.params.user_id),callback:function ($$v) {_vm.$set(_vm.params, "user_id", $$v)},expression:"params.user_id"}}),_c('searchInput',{staticClass:"col-md-3",attrs:{"title":"المشروع","plaseholder":"اختر مشروع","show":'name',"refrance":'id',"value":_vm.params.project_id,"values":_vm.$database.projects},model:{value:(_vm.params.project_id),callback:function ($$v) {_vm.$set(_vm.params, "project_id", $$v)},expression:"params.project_id"}}),_c('searchInput',{staticClass:"col-md-3",attrs:{"title":"المخزن","plaseholder":"اختر مخزن","show":'name',"refrance":'id',"value":_vm.params.store_id,"values":_vm.$database.stores},model:{value:(_vm.params.store_id),callback:function ($$v) {_vm.$set(_vm.params, "store_id", $$v)},expression:"params.store_id"}}),_c('searchInput',{staticClass:"col-md-3",attrs:{"title":"نقطة البيع","plaseholder":"اختر نقطة بيع","show":'name',"refrance":'id',"value":_vm.params.point_of_sale_id,"values":_vm.$database.pointOfSales},model:{value:(_vm.params.point_of_sale_id),callback:function ($$v) {_vm.$set(_vm.params, "point_of_sale_id", $$v)},expression:"params.point_of_sale_id"}}),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("رقم الجلسة")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.session_number),expression:"params.session_number"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"ادخل رقم الجلسة"},domProps:{"value":(_vm.params.session_number)},on:{"input":function($event){if($event.target.composing)return;_vm.$set(_vm.params, "session_number", $event.target.value)}}})])]),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("نوع الطلب")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.table_number),expression:"params.table_number"}],staticClass:"form-control",attrs:{"type":"text"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.params, "table_number", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("اختر نوع الطلب")]),_c('option',{attrs:{"value":"0"}},[_vm._v("تيك اواي")]),_c('option',{attrs:{"value":"1"}},[_vm._v("صاله")])])])]),_c('searchInput',{staticClass:"col-md-3",attrs:{"title":"مندوب االشحن","plaseholder":"اختر مندوب الشحن","show":'name',"refrance":'id',"value":_vm.params.delivery_id,"values":_vm.$database.deliveries},model:{value:(_vm.params.delivery_id),callback:function ($$v) {_vm.$set(_vm.params, "delivery_id", $$v)},expression:"params.delivery_id"}}),_c('searchInput',{staticClass:"col-md-3",attrs:{"title":"المسوق","plaseholder":"اختر مسوق","show":'name',"refrance":'id',"value":_vm.params.marketer_id,"values":_vm.$database.marketers},model:{value:(_vm.params.marketer_id),callback:function ($$v) {_vm.$set(_vm.params, "marketer_id", $$v)},expression:"params.marketer_id"}}),_c('actionButtons',{staticClass:"col-md-3"})],1)])]),_c('div',{attrs:{"id":"reportShow"}},[_c('reportHeader',{attrs:{"title":"المبيعات بالفاتورة","details":[
            {title: 'اسم العميل', value : _vm.customerName },
            {title: 'اسم المستخدم', value : _vm.userName },
            {title: 'المخزن', value : _vm.storeName },
            {title: 'نقطة البيع', value : _vm.pointOfSaleName },
            {title: 'رقم الجلسة', value : _vm.sessionNumber },
            {title: 'نوع الطلب', value : _vm.tableNumber },
            {title: 'مندوب الشحن', value : _vm.deliveryName },
            {title: 'المسوق', value : _vm.marketerName }
          ]}}),_c('reportTable',{attrs:{"emptyTableText":'لايوجد بيانات حاليا',"emptyTableSubText":'جرب اضافة البعض واعد المحاولة',"cloumns":[
            { column: 'code', link: '/invoices', title: 'الكود', type:'reportMainLink', sort: true, supData: true},
            {
              column: 'date',
              title: 'التاريخ',
              type: 'text',
              sort: true
            },
            {
              column: 'client_type',
              title: 'اسم العميل',
              type: 'clintLink',
              sort: false,
            },
            {
              column: 'user',
              title: 'المستخدم',
              type: 'text',
              sort: true,
              supData: true,
            },
            {column: 'status',    title: _vm.$t('orders.situation') ,type: 'status' , sort: true ,  values: [
              { title: _vm.$t('orders.NewOrder'), value: 1, color: 'dark'},
              { title: _vm.$t('orders.BeingProcessed'), value: 2, color: 'info' },
              { title: _vm.$t('orders.readyForShipping'), value: 3, color: 'info' },
              { title: _vm.$t('orders.UnderShipping'), value: 4, color: 'info' },
              { title: _vm.$t('orders.shipped'), value: 5, color: 'success' },
              { title: _vm.$t('orders.complete'), value: 6, color: 'success' },
              { title: _vm.$t('orders.returnd'), value: 7, color: 'danger'},
              { title: _vm.$t('orders.canceled'), value: 8, color: 'danger' },
            ]},
            {
              column: 'subtotal',
              title: 'الأجمالي',
              type: 'text',
              sort: true,
              supData: true
            },
            {
              column: 'edit',
              title: 'تعديل',
              type: 'text',
              sort: true,
              supData: true
            },
            {
              column: 'delivery',
              title: 'رسوم الشحن',
              type: 'text',
              sort: true,
              supData: true,
            },
            {
              column: 'tax',
              title: 'الضرائب',
              type: 'text',
              sort: true,
              supData: true
            },
            {
              column: 'discount',
              title: 'خصم',
              type: 'text',
              sort: true,
              supData: true,
            },
            {
              column: 'total',
              title: 'المجموع',
              type: 'text',
              sort: true,
            },
            {
              column: 'earning',
              title: 'الربح',
              type: 'text',
              sort: true,
              disable: !(this.$user.admin || this.$user.role.reports_earning_show),
              supData: true
            },
          ],"footer":[
            { colspan: _vm.$option.print_type == 1  ? 2 : 1, value: 'المجموع' },
            { colspan: 3, value: _vm.invoicesCount, supData: true },
            { colspan: 1, value: _vm.subtotal, supData: true},
            {
              colspan: 1,
              value: _vm.edit,
              supData: true,
            },
            { colspan: 1, value: _vm.delivery, supData: true },
            {
              colspan: 1,
              value: _vm.tax,
              supData: true,
            },
            {
              colspan: 1,
              value: _vm.discount,
              supData: true,
            },
            { colspan: 1, value: _vm.total },
            { colspan: 1, value: _vm.earning,  disable: !(this.$user.admin || this.$user.role.reports_earning_show), supData: true },
          ]}})],1)],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-header-title"},[_c('i',{staticClass:"fal fa-edit"}),_vm._v(" خيارات التقرير ")])])
}]

export { render, staticRenderFns }